import { Outlet, Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/features/auth/AuthContext'
import { Button } from '@/components/ui/button'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'

export function AdminLayout() {
  const { t } = useTranslation()
  const { signOut } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await signOut()
    navigate('/login')
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <div className="flex items-center gap-6">
            <Link to="/admin" className="text-xl font-bold">
              {t('admin.title')}
            </Link>
            <nav className="hidden md:flex items-center gap-4">
              <Link
                to="/admin/tenants"
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                {t('admin.tenants.title')}
              </Link>
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <Link to="/">
              <Button variant="ghost" size="sm">
                {t('common.backToHome')}
              </Button>
            </Link>
            <Button variant="outline" size="sm" onClick={handleLogout}>
              {t('auth.logout')}
            </Button>
          </div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  )
}
